<template>
  <footer class="footer">
    <div class="footer-content d-none d-md-block">
      <div class="help-section">
        <div class="col-md-7 pb-4 pt-4 pl-4">
          <h2 class="pb-3">¿Necesitas ayuda?</h2>
          <p >Consulta nuestras <a href="/pre-aprobado/preguntas-frecuentes" class="link-faq">Preguntas Frecuentes</a></p>
          <p>¡Resolvemos todas tus dudas!</p>
          <p class="contact-text">Contáctanos</p>
        </div>

        <div class="d-md-block col-md-6 py-5">
          <div class="contact-info pb-3">
            <div class="contact-item">
              <img src="@/assets/img/phone-icon-white.svg" alt="Mail" class="mail-icon" />
              <span>952 864 645</span>
            </div>
            <div class="contact-item">
              <img src="@/assets/img/mail-icon-white.svg" alt="Mail" class="mail-icon" />
              <span>info@ibancar.com</span>
            </div>
          </div>
         <p>Lunes a Viernes de 9:00 a 20:00</p>
          <p>Sábados de 10:00 a 14:00</p>
        </div>
      </div>

      <div class="pl-2">
        <div class="row">
            <div class="col-md-3">
              <div class="container d-none d-md-block">
                <div class="row">
                   <img class="d-none d-md-block" width="150" height="59" src="/img/logo_ibancar.1bbe0c8d.svg" alt="Ibancar" data-v-24d25cc4="">
                  <div class="col-md-6 py-3">
                    <a href="https://es.linkedin.com/company/ibancar-world" target="_blank" rel="noopener noreferrer">
                      <img class="linkdin-logo" src="@/assets/img/logo_linkedin.png" alt="LinkedIn" />
                    </a>
                  </div>
                  <div class="col-md-6"><img class="rgpd-logo" src="@/assets/img/rgpd_small_webp.webp" alt="RGPD" /></div>
                </div>
              </div>
            </div>
            <div class="col-md-9 pl-5">
              <FooterNav />
            </div>
        </div>
        <div class="col-lg-12 pl-4 pb-5 d-none d-md-block">
              <div class="t12">
                  <p class="card-text">Oferta de financiación sujeta a aprobación de Ibancar World SL en España. Préstamos al consumo entre 300€ y 8000€ y duración entre 6 y 48 meses. El TAE podrá variar en función de la cantidad a prestar. Variación de la TAE 29.77% (min.) y 132.11% (máx.) y TIN 19.80% (mín.) y 19.80% (máx.). Importe calculado para financiaciones realizadas el día 1 del mes, y primer vencimiento el 1 del mes siguiente; en caso de que las fechas difieran, el importe total puede sufrir pequeñas variaciones. Sistema de amortización francés.</p>
                  <p class="card-text">*Para un importe solicitado de 1000€, el importe financiado es 1150€ que incluye una comisión financiada de 150€ reembolsable en 36 cuotas mensuales de 41.23€ (amortización francesa). TAE: 49.18%, TIN: 19.80%. Importe de los intereses: 334.22€. Coste total del préstamo: 484.22€. Importe total adeudado: 1484.22€.</p>
                  <p class="card-text">*Para un importe solicitado de 6.000€, el importe financiado es 6.300€ que incluye una comisión financiada de 300€ reembolsable en 36 cuotas mensuales de 230.70€ (amortización francesa). TAE: 29.77%, TIN: 19.80%. Importe de los intereses: 2005.34€. Coste total del préstamo: 2305.34€. Importe total adeudado: 8305.34€.</p>
                  <p class="card-text">*Coste de servicios no incluidos</p>
              </div>
          </div>

    </div>
    </div>

    <!-- sección sm -->
     <div class="footer-mobile d-md-none px-4 py-4">
      <div class="container">
        <div class="row">
        <div class="col">
            <h2 class="text-white">¿Necesitas ayuda?</h2>
            <p class="text-white">
              Consulta las <a href="/pre-aprobado/preguntas-frecuentes" class="link-faq">preguntas más frecuentes</a><br />
              ¡Resolvemos todas tus dudas!-
            </p>
            
        </div>

        <div class="pl-2">
           <img class="d-none d-md-block" width="150" height="59" src="/img/logo_ibancar.1bbe0c8d.svg" alt="Ibancar" data-v-24d25cc4="">
           <div class="col-md-6 py-3">
            <a href="https://es.linkedin.com/company/ibancar-world" target="_blank" rel="noopener noreferrer">
              <img class="linkdin-logo" src="@/assets/img/logo_linkedin.png" alt="LinkedIn" />
            </a>
          </div>
           <div class="col-md-6"><img class="rgpd-logo" src="@/assets/img/rgpd_small_webp.webp" alt="RGPD" /></div>
        
        </div>
        </div>
    </div>
    <div class="container">
          <div class="row">
            <div class="col">
              <span>Lunes a Viernes de 9:00 a 20:00</span>
              <br/>
              <span>Sábados de 10:00 a 14:00</span>
            </div>
            <div class="pl-4">
              <div class="contact-item">
                <img src="@/assets/img/phone-icon-white.svg" alt="Teléfono" />
                <span>952 864 645</span>
              </div>
              <div class="contact-item">
                <img src="@/assets/img/mail-icon-white.svg" alt="Mail" />
                <span>info@ibancar.com</span>
              </div> 
            </div>
          </div>  
      </div>
      <div class="container">
      <div class="row">
        <div class="col-sm-12 text-white small">
          <FooterNav />
        </div>
      </div>
    </div>
    </div>

    <div class="copyright">
      <p>Copyright © Ibancar 2024</p>
    </div>
  </footer>
</template>
<script>
import FooterNav from './Landing/FooterNav.vue';

export default {
  components: {
    FooterNav,
  },
};
</script>

<style lang="scss" scoped>
@import "bootstrap/scss/_functions.scss";
@import "bootstrap/scss/_variables.scss";
@import "bootstrap/scss/_mixins.scss";
@import "@/assets/styles/variables.scss";


.footer {
  background-color: $blue;
  color: white;
}

.footer-content {
  max-width: 1440px;
  margin: 0 auto;
  padding: 2rem;
  padding-bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.link-faq{
  color: white;
  text-decoration: underline;
  font-weight: 600;
}

.help-section {
  h2 {
    font-size: 0.95rem;
    font-weight: 700;
    margin-bottom: 1.2rem;
  }

  p {
    margin: 0.35rem 0;
    font-size: 0.70rem;
    font-weight: 600;
  }


}

.contact-info {
  margin-top: 1rem;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0.5rem 0;
  
  img {
    width: 12px;
    height: 12px;
    color: white;
    
  }
  span {
    font-size: 0.70rem;
    font-weight: 700;
  }
}

.social-section {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 1rem;
  align-items: flex-end;

  .linkedin-logo {
    width: 50px;
  }

  .rgpd-logo {
    width: 50px;
  }
}

.link-section{
  display: flex;
  justify-content: center;
  gap: 1rem;
  padding-block: 1rem;
  a{
    color: white;
    font-size: 0.5rem;
    font-weight: 500;
    text-decoration: none;
  }
}

.copyright {
  background-color: #000;
  text-align: center;
  padding: 0.5rem;
  
  p {
    margin: 0;
    font-size: 0.875rem;
  }
}

@include media-breakpoint-up(md) {

  .footer-content {
    flex-direction: column;
    padding: 2rem 5rem;
    padding-bottom: 0;
  }

  .help-section {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    
    h2 {
      margin-bottom: 0;
    }

    .contact-info {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      margin-top: 0.5rem;
    }

    .contact-text {
      margin: 0;
    }
  }

  .social-section {
    padding: 1rem 0;
    margin-top: 1rem;
    border-top: 1px solid white;
    flex-direction: row-reverse;
    width: 100%;
    justify-content: space-between;

    .rgpd-logo {
      width: 80px;
    }

    .ibancredit-logo {
      width: 200px;
    }
  }
  .link-section{
    a{
      font-size: 0.75rem;
    }
  }
}

@include media-breakpoint-up(lg) {

  .footer-content {
    flex-direction: column;
    padding: 3rem 6rem;
    padding-bottom: 0;
  }

  .help-section {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-end;

    p{
      font-size: 1.2rem;
    }
    
    h2 {
      margin-bottom: 0;
      font-size: 1.9rem;
    }

    .contact-info {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      margin-top: 0.5rem;

      .contact-item {
        img {
          width: 20px;
          height: 20px;
        }

        span {
          font-size: 1.2rem;
        }
      }
    }

    .contact-text {
      margin: 0;
      font-size: 1.2rem;
    }
  }

  .social-section {
    padding: 1rem 0;
    margin-top: 1rem;
    border-top: 1px solid rgba(255, 255, 255, 0.272);
    flex-direction: row-reverse;
    width: 100%;
    justify-content: space-between;

    .rgpd-logo {
      width: 100px;
    }

    .ibancredit-logo {
      width: 200px;
    }
  }

  .link-section{
    gap: 2rem;
    a{
      font-size: 1.25rem;
    }
  }
}
</style>
